module.exports = __webpack_public_path__ + "img/order.f50a87b7.svg";